import React from 'react';
import { formatDateForDisplay } from '../../utils/dateFormatter';
import { getDocumentTypeText } from '../../utils/documentTypeUtils';

// 代理店登録確認ポップアップコンポーネント
export const AgencyRegistrationPop = ({
  showConfirmationPopup,
  formData,
  closeConfirmationPopup,
  confirmRegistration,
  activeTab,
  documentTypes = []
}) => {
  if (!showConfirmationPopup) return null;
  
  // アクティブなタブに基づいて表示するコンテンツを決定
  const renderContent = () => {
    switch(activeTab) {
      case 'info':
        const documentTypeText = getDocumentTypeText(formData.documentTypeIds, documentTypes);

        return (
          <>
            <div className="confirmation-files">
              <div className="confirmation-file-item font-large">
                <div className="file-path">取引先コード: {formData.tradingCode}</div>
              </div>
              <div className="confirmation-file-item font-large">
                <div className="file-path">アカウント名（メールアドレス）: {formData.accountname}</div>
              </div>
              <div className="confirmation-file-item font-large">
                <div className="file-path">代理店名: {formData.name}</div>
              </div>
              <div className="confirmation-file-item font-large">
                <div className="file-path">代理店カナ: {formData.nameKana}</div>
              </div>
              <div className="confirmation-file-item font-large">
                <div className="file-path">契約日: {formatDateForDisplay(formData.contractDate)}</div>
              </div>
              <div className="confirmation-file-item font-large">
                <div className="file-path">解除日/契約終了日: {formatDateForDisplay(formData.cancellationDate) || '未設定'}</div>
              </div>
              <div className="confirmation-file-item font-large">
                <div className="file-path">郵便番号: {formData.postalCode}</div>
              </div>
              <div className="confirmation-file-item font-large">
                <div className="file-path">住所: {formData.prefecture}{formData.city}{formData.building}</div>
              </div>
              <div className="confirmation-file-item font-large">
                <div className="file-path">電話番号: {formData.phoneNumber}</div>
              </div>
              <div className="confirmation-file-item font-large">
                <div className="file-path">文書種別: {documentTypeText}</div>
              </div>
            </div>
          </>
        );
      case 'insurance':
        return (
          <div className="confirmation-files">
            <div className="confirmation-file-item font-large">
              <div className="file-path">選択された保険会社の登録を行います</div>
            </div>
          </div>
        );
      case 'solicitors':
        return (
          <>
            <div className="confirmation-files">
              <div className="confirmation-file-item font-large">
                <div className="file-path">支店名: {formData.branchName}</div>
              </div>
              <div className="confirmation-file-item font-large">
                <div className="file-path">アカウント名（メールアドレス）: {formData.accountname}</div>
              </div>
              <div className="confirmation-file-item font-large">
                <div className="file-path">担当者名漢字: {formData.name}</div>
              </div>
              <div className="confirmation-file-item font-large">
                <div className="file-path">担当者カナ: {formData.nameKana}</div>
              </div>
              <div className="confirmation-file-item font-large">
                <div className="file-path">利用開始日: {formatDateForDisplay(formData.startDate) || '未設定'}</div>
              </div>
              <div className="confirmation-file-item font-large">
                <div className="file-path">利用終了日: {formatDateForDisplay(formData.endDate) || '未設定'}</div>
              </div>
              <div className="confirmation-file-item font-large">
                <div className="file-path">プロフィール: {formData.profile}</div>
              </div>
            </div>
          </>
        );
      default:
        return null;
    }
  };
  
  // タブに応じたタイトルの決定
  const getTitle = () => {
    switch(activeTab) {
      case 'info': return '代理店情報登録確認';
      case 'insurance': return '登録保険会社登録確認';
      case 'solicitors': return '募集人登録確認';
      default: return '登録確認';
    }
  };
  
  return (
    <div className="confirmation-popup-overlay">
      <div className="confirmation-popup-container">
        <div className="confirmation-popup-content">
          <h2 className="confirmation-title">{getTitle()}</h2>
          
          <div className="confirmation-details-02">
            {renderContent()}
            
            <div className="confirmation-comment">
              <div className="comment-header-error">注意事項</div>
              <div className="comment-content comment-content--error">
                上記の内容で登録を行います。
                よろしいですか？
              </div>
            </div>
          </div>
          
          <div className="action-buttons c-max-mini c-m-center">
            <button 
              className="button button-secondary button-medium" 
              onClick={closeConfirmationPopup}
            >
              キャンセル
            </button>
            <button 
              className="btn btn-primary button-medium" 
              onClick={confirmRegistration}
            >
              登録する
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AgencyRegistrationPop;
